import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5414b34e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "artistSyno"
};
var _hoisted_2 = {
  class: "desc-box"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 歌手描述 "), _ctx.artistDesc.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artistDesc, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "desc-item",
      key: item
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.ti), 1
    /* TEXT */
    ), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.txt.split('\n'), function (text) {
      return _openBlock(), _createElementBlock("div", {
        class: "text",
        key: text
      }, [_createElementVNode("span", null, _toDisplayString(text), 1
      /* TEXT */
      )]);
    }), 128
    /* KEYED_FRAGMENT */
    ))]);
  }), 128
  /* KEYED_FRAGMENT */
  ))])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无详情数据~"))], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}